// global webpack.DefinePlugin vars
declare const WANTABLE_GOOGLE_CLIENT_ID:string;
declare const WANTABLE_FACEBOOK_APP_ID:string;
declare const WANTABLE_APP_DOMAIN:string;

export const WANTABLE_API_BASE_URL = `${WANTABLE_APP_DOMAIN}/api/shopify`;
export const GOOGLE_CLIENT_ID = WANTABLE_GOOGLE_CLIENT_ID;
export const FACEBOOK_APP_ID = WANTABLE_FACEBOOK_APP_ID;

export const CACHED_TOKEN_KEY = "wantable-shopify-token";
export const CACHED_USER_DATA_KEY = "wantable-user-data";

// custom named events
export const TOKEN_STORED = 'token-stored';
export const TOKEN_REMOVED = 'token-removed';

// Reused Variables - Doing here for now
export const SUPPORT_PHONE = '8559268225';
export const SUPPORT_EMAIL = 'hello@wantable.com';
